import { action, makeObservable, observable } from 'mobx';
import { computedFn } from 'mobx-utils';
import CannedMessage from '../models/cannedMessage';
import processIncomingData from '../processIncomingData';
import * as utils from '../../helpers/utils';

class CannedMessageStore {
  constructor(rootStore) {
    makeObservable(this);
    this.rootStore = rootStore;
  }

  @observable cannedMessages = [];

  computedGetCannedMessagesForChannelType = computedFn(
    function computedGetCannedMessagesForChannelType(channelTypeId) {
      let filteredCannedMessages = [];

      if (channelTypeId === utils.ChannelTypeEnum.SMS.TypeId) {
        filteredCannedMessages = this.cannedMessages.filter(
          (m) =>
            (m.CannedMessageType === null ||
              m.CannedMessageType?.TypeName === utils.ChannelTypeEnum.SMS.TypeName) &&
            !m.IsDeleted
        );
      } else if (channelTypeId === utils.ChannelTypeEnum.WebChat.TypeId) {
        filteredCannedMessages = this.cannedMessages.filter(
          (m) =>
            m.CannedMessageType?.TypeName === utils.ChannelTypeEnum.WebChat.TypeName && !m.IsDeleted
        );
      }

      return filteredCannedMessages.sort(
        (a, b) => new Date(b.CreationDate) - new Date(a.CreationDate)
      );
    }
  );

  @action actionDeleteMessage = (message) => {
    this.cannedMessages = this.cannedMessages.filter((m) => m._id !== message._id);
  };

  @action UpsertAndGet(incObj) {
    return processIncomingData(incObj, this.rootStore, this.cannedMessages, CannedMessage);
  }
}

export default CannedMessageStore;
